// removed by extract-text-webpack-plugin
module.exports = {"chart-headline":"chart-headline___3wc10 center___2iqBf","chart-headline-text":"chart-headline-text___9NmiS","chart-sublede":"chart-sublede___oM1X9 h4___kHWTn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardDefaultAllocation/PlanScorecardDefaultAllocation.css
// module id = 897
// module chunks = 0